import React from "react";

export default function Contact() {
  return (
    <div className=" contact a11y-readable max-w-7xl mx-auto py-16 px-6">
      <header className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl font-semibold h-font text-green-700">
          Contact Us
        </h1>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        <div className="glass card-glow p-6 rounded-xl">
          <h2 className="text-xl font-semibold mb-4">Apar Growth Partners</h2>
          <p className="text-slate-700 mb-2">
            Individual license – Aman R. Shah
          </p>
          <p className="text-slate-700 mb-2">
            SEBI Regn No.: <strong>INA000020730</strong>
          </p>
          <p className="text-slate-700 mb-2">
            Unit No. 129, Gala Industrial Estate, 2nd floor,
            <br /> Dindayal Upadhyay Marg, Mulund (West), Mumbai – 400080
          </p>
          <p className="text-slate-700">
            <strong>Email:</strong> info@apargrowth.com
          </p>

          <div className="mt-4">
            <a
              href="https://www.linkedin.com/in/aman-shah-078501a9?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm text-green-700 underline"
            >
              View LinkedIn profile
            </a>
          </div>
        </div>

        <div className="glass card-glow p-6 rounded-xl">
          <h2 className="text-xl font-semibold mb-4">Get in Touch</h2>
          <form className="space-y-4">
            <div>
              <label htmlFor="contact-page-name" className="block text-sm font-medium text-slate-600 mb-1">
                Name
              </label>
              <input
                id="contact-page-name"
                name="name"
                autoComplete="name"
                type="text"
                className="w-full px-4 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-green-600 outline-none"
                placeholder="Your Name"
              />
            </div>
            <div>
              <label htmlFor="contact-page-email" className="block text-sm font-medium text-slate-600 mb-1">
                Email
              </label>
              <input
                id="contact-page-email"
                name="email"
                autoComplete="email"
                type="email"
                className="w-full px-4 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-green-600 outline-none"
                placeholder="Your Email"
              />
            </div>
            <div>
              <label htmlFor="contact-page-message" className="block text-sm font-medium text-slate-600 mb-1">
                Message
              </label>
              <textarea
                id="contact-page-message"
                name="message"
                rows="4"
                className="w-full px-4 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-green-600 outline-none"
                placeholder="Your Message"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-green-700 hover:bg-green-800 text-white font-semibold py-3 rounded-lg transition"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
